export default "__VITE_ASSET__uL4oDhkj__"